<template>
  <base-dialog v-model="dialog.show" max-width="500px" scrollable width="50%">
    <template v-slot:title>
      {{ dialog.title }} {{ $t('sidebar.raster-type.name') }}
    </template>
    <base-form ref="form" @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.code"
            autofocus
            :error-messages="dialog.errors.code"
            label="Mã"
            required
            filled
            dense
            @focus="dialog.errors.code = ''"
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.name"
            :error-messages="dialog.errors.name"
            label="Tên hiển thị"
            required
            filled
            dense
            @focus="dialog.errors.name = ''"
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.description"
            :error-messages="dialog.errors.description"
            label="Mô tả"
            filled
            dense
            rows="3"
            type-input="v-textarea"
            @focus="dialog.errors.description = ''"
          ></field-group>
        </v-col>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button color="primary" :loading="dialog.loading" @click="onSubmit">
        {{ dialog.title }}
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { API_RASTER_TYPE } from '@api'
import { copyByJson } from '@utils'
import { EDIT_TYPE } from '@/src/constant'

export default {
  data: () => ({
    dialog: {
      show: false,
      form: {},
      errors: {},
      title: '',
      type: '',
      loading: false,
    },
  }),
  computed: {
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    open(item, type = EDIT_TYPE.CREATE) {
      this.dialog.show = true
      this.dialog.form = Object.assign(
        { code: '', name: '', description: '' },
        copyByJson(item)
      )
      this.dialog.title = this.$t('actions.' + type)
      this.dialog.type = type
      this.dialog.errors = {}
      this.dialog.loading = false
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        form: {},
        type: EDIT_TYPE.CREATE,
        errors: {},
      }
    },
    async onSubmit() {
      if (!(await this.$refs['form'].validate())) {
        return false
      }
      try {
        let data = Object.assign({}, this.dialog.form)
        this.dialog.loading = true
        let res = this.isCreateDialog
          ? await API_RASTER_TYPE.create(data)
          : await API_RASTER_TYPE.update(data.id, data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.errors = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>
